export default {
  home: 'Strona główna',
  menu: 'Menu',
  orders: 'Zamówienia',
};
